import React, {useContext} from "react";
import VendorUsers from "../VendorUsers/VendorUsers";
import {SocketContext} from "../../../contexts/SocketContext";
import UiContext from "../../../contexts/UiContext";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";

type Props = {};

export const VendorUsersWrapper = (props: Props) => {
    const socket = useContext(SocketContext)!
    const uiContext = useContext(UiContext);
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    return <VendorUsers
        socket={socket}
        setActivityIndicator={uiContext.setActivityIndicator}
        notifyFn={uiContext.notifyFn}
        setSidebarComponent={uiContext.setSidebarComponent}
        toggleSidebar={uiContext.toggleSidebar}
        supplierModel={supplierModel}
        userModel={userModel}
    />;
};
